import React, {FC, useState} from 'react'
import {IconCache} from './IconCache'

export const WithIconCache: FC = ({children}) => {
  const [icons, setIcons] = useState({})
  const [loading, setLoading] = useState<string[]>([])
  return (
    <IconCache.Provider
      value={{
        icons,
        loading,
        cacheIcon: (path: string, icon: string) => {
          if (!icon[path]) {
            icons[path] = icon
            setIcons({...icons})
          }
        },
        startLoadingIcon: (path: string) => {
          if (loading.indexOf(path) > -1) {
            return false
          }
          loading.push(path);
          setLoading([...loading])
          return true
        }
      }}
    >
      {children}
    </IconCache.Provider>
  )
}
